import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './components/App';
import { initializeApplicationInsights } from './diagnostics/applicationInsights';
import { OidcProvider } from './components/login/OidcProvider';
import configureLogging from './diagnostics/configureLogging';
import { initialAppState } from './models/state/appState';
import userManager from './services/userManager';
import configureStore from './store/configureStore';
import './styles/index.scss';

configureLogging();
initializeApplicationInsights();

if (typeof env !== 'undefined' && env === 'live') {
  // Ensure no console output in live builds.
  const noop = () => {};
  console.debug = noop;
  console.info = noop;
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

const store = configureStore(initialAppState);

if (import.meta.env.DEV) {
  (window as any).store = store;
}

// Start the landing page downloads alongside sign-in and the company lookup rather than after them.
// Failures are ignored here because the route's own lazy import retries and reports them.
if (/^\/company\/\d+\/account\/\d+\//.test(window.location.pathname)) {
  import('./components/account/AccountRoutes').catch(() => {});
}
if (/^\/company\/\d+\/(account\/\d+\/)?sim\/?$/.test(window.location.pathname)) {
  import('./components/sim/simsPage/SimsPage').catch(() => {});
}

createRoot(document.getElementById('react-app')!).render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </OidcProvider>
  </Provider>
);

// Allow Hot Module Replacement (Vite)
if (import.meta.hot) {
  import.meta.hot.accept();
}
